import {StrictMode, useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reducers from './reducers';
import thunk from 'redux-thunk';
import 'animate.css/animate.css';
import {BrowserRouter as Router, useLocation} from 'react-router-dom';
import ReactGA from "react-ga4";
import { G_MEASURE_ID } from './constants/globalVar';

const store = createStore(reducers, compose(applyMiddleware(thunk)));

// Initialize Google Analytics
ReactGA.initialize(G_MEASURE_ID);

// Page Tracking component
function PageTracker({ children }) {
  const location = useLocation();

  useEffect(() => {
    // Track page view
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return children;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <Router>
          <PageTracker>
            <App />
          </PageTracker>
        </Router>
      </HelmetProvider>
    </Provider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
